import { ServicePriceCalculationParametersProps } from '@services/requests/servicesService/servicesServicesService/interface';
import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

/**
 * Агрегирующий запрос сущностей директорий дополнительных услуг
 */
export class ServicesServicePriceCalculationMutation
  implements GraphQLQuery<ServicePriceCalculationParametersProps>
{
  readonly query: any;

  readonly variables: ServicePriceCalculationParametersProps;

  readonly isSilent: boolean;

  constructor(params: ServicePriceCalculationParametersProps, isSilent = false) {
    this.isSilent = isSilent;
    this.variables = {
      services: params.services,
      short_link: params.short_link,
      bitrix_user: params.bitrix_user,
    };
    this.query = gql`
      mutation calculateServicePrice(
        $services: [ServicePriceCalculationParameters]
        $short_link: String
        $bitrix_user: Int
      ) {
        servicesServicePriceCalculation(
          services: $services
          short_link: $short_link
          bitrix_user: $bitrix_user
        ) {
          stateID
          currencyId
          result {
            data {
              currency_id
              service_id
              tax_id
              formula
              is_include_tax
              fields_with_limitations {
                id
                limitations
                price_offer_id
                services_field_id
              }
              fields_with_limitations_ids
              id
              is_active
              is_default
            }
            result {
              basePrice
              priceInTargetCurrency
              taxInTargetCurrency
              computedAmount
              conversionFee
			        fullPriceInTargetCurrency
			        innerCurrency
            }
            token
          }
          serviceId
          isPriceByRequest
		  errorMessage
        }
      }
    `;
  }
}
